import axios from '~/api/axiosBase'

export const fetchOnboardingStatus = async (storeId) => {
  const response = await axios.get(`api/stores/${storeId}/checklist`)
  return response.data
}

export const claimReward = async (storeId) => {
  const response = await axios.post('api/user/checklist/claim-reward', { store_id: storeId })
  return response.data
}

export const uploadWixReview = async (storeId, file) => {
  const formData = new FormData()
  formData.append('file', file)
  const response = await axios.post(`api/stores/${storeId}/checklist/wix-review`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}
